import { Municipality } from '@ta-interaktiv/react-municipality-search'
import { unityPropsContext } from 'components/UnityPropsContext'
import React, { FC, ReactElement, useContext } from 'react'
import styled from 'styled-components'
import AnsweringSlider from './AnsweringSlider'
import QuestionTitle from './QuestionTitle'
import QuestionImage from './QuestionImage'
import type { Question as Q } from 'Types/Questions'

interface Props {
  question: Q
  selectedMunicipality?: Municipality
  guesses?: Guesses
  isNationalOnly?: boolean
  unit: string
  min: number
  max: number
  tenant: any
}

const Question: FC<Props> = ({
  question,
  selectedMunicipality,
  guesses,
  isNationalOnly = false,
  unit,
  min,
  max,
  tenant,
}): ReactElement => {
  const unityProps = useContext(unityPropsContext)

  return (
    <Container>
      {question.meta.image && <QuestionImage question={question} />}
      <Section>
        <QuestionTitle hideLocation={isNationalOnly} question={question} />
        <AnsweringSlider
          guessedAnswer={guesses?.nationalAverages?.[question.id]}
          question={question}
          selectedBfsId={selectedMunicipality?.GDENR}
          unit={unit}
          min={min}
          max={max}
          step={1}
          tenant={tenant}
        />
        <Source>
          {unityProps.source}{' '}
          {question.meta.source.map((s) => (
            <a href={s.sourceUrl} target='_blank' rel='noreferrer'>
              {s.sourceTitle}
            </a>
          ))}
        </Source>
      </Section>
    </Container>
  )
}
const Section = styled.section`
  counter-increment: question;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--gray-4);
  padding: 3em;
  padding-top: 0.5em;
  max-width: 669px;
  margin: 0 auto;

  @media screen and (max-width: 600px) {
    padding: 0.5em;
  }
`
const Source = styled.div`
  font-size: 1.2em;
  @media screen and (max-width: 600px) {
    font-size: 1em;
  }
  margin-top: 2em;
  color: #999;
  a {
    color: #6caaf0;
    text-decoration: none;
  }
`

const Container = styled.div`
  padding: 30px 0;
`

export default Question
